/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DismissAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Dismiss from './Dismiss/index'
import No from './No/index'
import React from 'react'
import UnDismiss from './UnDismiss/index'



/** @type {import('Simple/types.js').View} */
export default function DismissAction({
  children,
  viewPath = "/DesignSystem/LeadPreview/Content/DismissAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let leadValueData = fromData.useDataFormat({ viewPath,
context: 'lead',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: leadValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Dismiss'}>
<Dismiss
  viewPath={`${viewPath}/Dismiss`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'UnDismiss'}>
<UnDismiss
  viewPath={`${viewPath}/UnDismiss`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}